"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Date = exports.DateLocale = exports.TEST_ID_TIME = void 0;
/** @jsxRuntime classic */
/** @jsx jsx */
var luxon_1 = require("luxon");
var theme_ui_1 = require("theme-ui");
exports.TEST_ID_TIME = "time";
var DateLocale;
(function (DateLocale) {
    DateLocale["ENGLISH_GB"] = "en-GB";
    DateLocale["GERMAN_DE"] = "de-DE";
    DateLocale["FRENCH_FR"] = "fr-FR";
    DateLocale["PORTUGUESE_BR"] = "pt-BR";
})(DateLocale = exports.DateLocale || (exports.DateLocale = {}));
function Date(_a) {
    var timestamp = _a.timestamp, _b = _a.locale, locale = _b === void 0 ? "en-GB" : _b, csx = _a.csx;
    var dateTime = luxon_1.DateTime.fromMillis(timestamp).setLocale(locale);
    var readableDate = dateTime.toFormat("d MMMM y");
    var standardDate = dateTime.toFormat("dd-MM-y");
    return (theme_ui_1.jsx("time", { "data-testid": exports.TEST_ID_TIME, dateTime: standardDate, sx: __assign({ variant: "text.small" }, csx) }, readableDate));
}
exports.Date = Date;
